import { HttpEvent, HttpHandlerFn, HttpRequest, HttpResponse } from '@angular/common/http';
import { map, Observable } from 'rxjs';

const ISO_DATE_REGEX = /^\d{4}-\d{2}-\d{2}(?:T\d{2}:\d{2}:\d{2}(?:\.\d*)?Z?)?$/;

export function httpResponseInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  return next(request).pipe(
    map(httpEvent => {
      if (httpEvent instanceof HttpResponse) {
        parseIsoDates(httpEvent.body);
      }
      return httpEvent;
    }),
  );
}

function parseIsoDates(object: any) {
  if (!object || typeof object !== 'object') {
    return object;
  }
  Object.entries(object)
    .filter(([, value]) => !!value)
    .forEach(([key, value]) => {
      if (typeof value === 'string' && ISO_DATE_REGEX.test(value)) {
        object[key] = new Date(value);
      } else if (Array.isArray(value)) {
        value.forEach(v => parseIsoDates(v));
      } else if (typeof value === 'object') {
        parseIsoDates(value);
      }
    });
}
